module.exports = __webpack_public_path__ + "static/media/cross_gray.b17cf23e.svg";